import { createSelector } from 'reselect';

import { selectChannelsById } from 'store/programs/selectors';
import { selectActiveUserProfile } from 'store/user/selectors';

import { DEFAULT_SUBTITLES_FONT_SIZE } from 'screens/Settings/constants.ts';

import { ReduxStore } from '../types';
import { AUDIO_SUBTITLES_HUNGARIAN, AUDIO_SUBTITLES_OFF } from './utils';

const selectStore = (store: ReduxStore) => {
    return store;
};

export const selectPlayerConfig = createSelector(
    selectStore,
    (store) => store.player,
);

export const selectPlayerChannel = createSelector(
    selectPlayerConfig,
    selectChannelsById,
    ({ videoItem }, channelsById) => {
        if (!videoItem?.channelId || !channelsById) {
            return undefined;
        }

        return channelsById?.[videoItem.channelId];
    },
);

export const selectPlayerSubtitles = createSelector(
    selectActiveUserProfile,
    selectPlayerConfig,
    (profileId, { subtitles }) => {
        if (!profileId) {
            return AUDIO_SUBTITLES_OFF;
        }

        return subtitles[profileId] || AUDIO_SUBTITLES_OFF;
    },
);

export const selectPlayerAudio = createSelector(
    selectActiveUserProfile,
    selectPlayerConfig,
    (profileId, { audio }) => {
        if (!profileId) {
            return AUDIO_SUBTITLES_HUNGARIAN;
        }

        return audio[profileId] || AUDIO_SUBTITLES_HUNGARIAN;
    },
);

export const selectSubtitlesFontSize = createSelector(
    selectActiveUserProfile,
    selectPlayerConfig,
    (profileId, { subtitlesFontSize }) => {
        if (!profileId) {
            return DEFAULT_SUBTITLES_FONT_SIZE;
        }

        return subtitlesFontSize[profileId] || DEFAULT_SUBTITLES_FONT_SIZE;
    },
);

export function selectPlayerUpdateId(store: ReduxStore) {
    return store.player.shouldUpdateId;
}

export function selectModalPlayerFullscreen(store: ReduxStore) {
    return store.player.fullscreen;
}

export function selectSpotlightVideoVisible(store: ReduxStore) {
    return store.player.spotlightVideoVisible;
}

export function selectPlayerIsMuted(store: ReduxStore) {
    return store.player.muted;
}

export function selectPlayerVolume(store: ReduxStore) {
    return store.player.volume;
}
